// hooks/useCurrentUser.ts

import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { updateUserData } from '@/lib/store/slices/UserSlice';
import { setPermissions } from '@/lib/store/slices/PermissionsSlice';
import { getUserDetailsService } from '@/services/auth';
import { getScreensPermissions } from '@/services/masters';
import { storage } from '@/lib/storage';
import { getUserIdFromToken } from '@/lib/jwt';

export function useCurrentUser() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootState) => state.user);

  const fetchUser = useCallback(async () => {
    try {
      const authToken = storage.getAuthToken();
      const userId = getUserIdFromToken(authToken!);
      if (userId) {
        const [{ data }, permRes] = await Promise.all([
          getUserDetailsService(Number(userId)),
          getScreensPermissions(),
        ]);
        dispatch(updateUserData(data as any));
        if (permRes.status === 200 && permRes.data) {
          const perms = (permRes.data as any).permissions ?? {};
          storage.setPermissions(perms);
          dispatch(setPermissions(perms));
        }
      }
    } catch (error) {
      console.error('Failed to fetch user:', error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!userDetails && storage.getAuthToken()) {
      fetchUser();
    }
  }, [userDetails, fetchUser]);

  return userDetails;
}
